import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Grid, StarRating, Text, Textarea } from '@siteground/styleguide';

import { sendChatFeedback } from '../../app-communication/actions/from-client-frontend';
import { ChatHeader } from '../../components/chat-header';
import { ChatLayout } from '../../components/chat-layout';
import { ChatMessages } from '../../components/chat-messages';
import { ROUTES } from '../../constants/routes';
import { CHAT_MAX_HEIGHT, isDeviceHeightBelow } from '../../utils/display';

const MIN_RATE_FOR_TEXTAREA = 3;

const ChatEnd = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const history = useHistory();
  const [rating, setRating] = React.useState(5);
  const [feedback, setFeedback] = React.useState(null);

  const handleStarRatingClick = (rate) => {
    setRating(rate);
    if (rate > MIN_RATE_FOR_TEXTAREA) {
      setFeedback(null);
    }
  };

  const handleFeedbackSubmit = () => {
    dispatch(
      sendChatFeedback({
        visitor_comments: feedback,
        visitor_rating: rating,
        onComplete: () => history.push(ROUTES.THANK_YOU)
      })
    );
  };

  return (
    <ChatLayout
      enableActionMenu
      header={<ChatHeader />}
      content={<ChatMessages />}
      footer={
        <Grid padding="large" justifyItems="center" style={{ width: '100%' }}>
          <Text align="center" role="heading">
            {intl.formatMessage({ id: 'translate.chat.rate.title' })}
          </Text>

          <StarRating
            rating={rating}
            onClick={handleStarRatingClick}
            onMouseOut={() => setRating(rating)}
            role="radiogroup"
          />

          {rating <= MIN_RATE_FOR_TEXTAREA && (
            <Textarea
              autoFocus
              rows={isDeviceHeightBelow(CHAT_MAX_HEIGHT) ? '2' : '4'}
              label={intl.formatMessage({ id: 'translate.chat.rate.textarea.label' })}
              value={feedback}
              onChange={(event) => setFeedback(event.target.value)}
            />
          )}

          <Button color="primary" onClick={handleFeedbackSubmit}>
            {intl.formatMessage({ id: 'translate.generic.submit' })}
          </Button>
        </Grid>
      }
    />
  );
};

export default ChatEnd;
